class VariantSelectorDropdown {
  constructor(selectorElement) {
    this.element = selectorElement;
    
    // Safely get product data from product-json element
    try {
      const productJsonElement = document.getElementById('product-json');
      this.product = productJsonElement ? JSON.parse(productJsonElement.textContent || '{}') : {};
    } catch (error) {
      console.warn('Error parsing product JSON:', error);
      this.product = { variants: [] };
    }
    
    this.closedButton = this.element.querySelector('[data-selector-state="closed"]');
    this.selectedButton = this.element.querySelector('[data-selector-state="selected"]');
    this.optionsContainer = this.element.querySelector('[data-selector-options]');
    this.optionButtons = this.element.querySelectorAll('.variant-selector-option');
    this.closeButton = this.element.querySelector('.variant-selector-close');
    this.formId = this.element.getAttribute('data-form-id') || this.element.closest('form')?.id;
    
    // Create backdrop for mobile modal
    this.backdrop = document.createElement('div');
    this.backdrop.className = 'variant-selector-backdrop';
    this.element.after(this.backdrop);
    
    // Find buy button in the page
    this.buyButton = document.querySelector('[data-block-type="buy-buttons"]');
    
    // Find delivery estimates
    this.deliveryEstimates = document.querySelectorAll('.delivery-estimate');
    
    this.state = 'closed';
    this.selectedVariantId = null;
    
    this.init();
    this.initNotifyMeButtons();
  }
  
  init() {
    // Always start with closed state
    this.updateState('closed');
    
    // We add to cart directly when selecting a variant
    // So we hide the buy button
    // Now it's hidden via JS - so this is commented out

    // if (this.buyButton) {
    //   this.buyButton.style.visibility = 'hidden';
    //   this.buyButton.style.position = 'absolute';
    //   this.buyButton.style.pointerEvents = 'none';
    // }
    
    // Add event listeners
    if (this.closedButton) {
      this.closedButton.addEventListener('click', () => this.toggleOptions());
    }
    
    if (this.selectedButton) {
      this.selectedButton.addEventListener('click', () => this.toggleOptions());
    }
    
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.updateState(this.selectedVariantId ? 'selected' : 'closed');
      });
    }
    
    // Handle clicks on the backdrop to close the modal
    this.backdrop.addEventListener('click', () => {
      this.updateState(this.selectedVariantId ? 'selected' : 'closed');
    });
    
    this.optionButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.selectVariant(button);
      });
    });
    
    // Close dropdown when clicking outside (desktop only)
    document.addEventListener('click', (event) => {
      // Check if it's not mobile
      if (window.innerWidth >= 700 && !this.element.contains(event.target) && this.state === 'opened') {
        this.updateState(this.selectedVariantId ? 'selected' : 'closed');
      }
    });
    
    // Initial state - show delivery estimate for the selected variant if available
    this.updateDeliveryEstimate();
  }
  
  initNotifyMeButtons() {
    this.element.querySelectorAll('.variant-notify-me').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const variantOption = button.closest('.variant-selector-option');
        if (variantOption && this.formId) {
          const variantId = parseInt(variantOption.getAttribute('data-variant-id'));
          const form = document.getElementById(this.formId);
          
          if (form) {
            form.dispatchEvent(
              new CustomEvent("variant:change", {
                bubbles: true,
                detail: {
                  variant: this.findVariantById(variantId)
                }
              })
            );
            
            const klaviyoTrigger = document.querySelector('.klaviyo-bis-trigger');
            if (klaviyoTrigger) {
              klaviyoTrigger.click();
            }
          }
        }
      });
    });
  }
  
  getUrlVariantId() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    return variantId ? parseInt(variantId) : null;
  }
  
  toggleOptions() {
    if (this.state === 'closed' || this.state === 'selected') {
      this.updateState('opened');
    } else {
      this.updateState(this.selectedVariantId ? 'selected' : 'closed');
    }
  }
  
  updateState(newState) {
    if (!this.element) return;
    
    this.state = newState;
    this.element.setAttribute('data-state', newState);
    
    // Toggle body class for mobile modal
    if (newState === 'opened') {
      document.body.classList.add('variant-selector-open');
    } else {
      document.body.classList.remove('variant-selector-open');
    }
    
    // Show buy button only when a variant is selected
    // UPDATE : now we hide the buy button via CSS & we add to cart directly when selecting a variant
    
    // if (this.buyButton) {
    //   this.buyButton.style.display = newState === 'selected' ? '' : 'none';
    // }
    
    if (this.closedButton) {
      this.closedButton.setAttribute('aria-expanded', newState === 'opened');
    }
    
    if (this.selectedButton) {
      this.selectedButton.setAttribute('aria-expanded', newState === 'opened');
    }
  }
  
  selectVariant(button, updateForm = true) {
    if (!button) return;
    
    const variantId = parseInt(button.getAttribute('data-variant-id'));
    if (!variantId) return;
    
    this.selectedVariantId = variantId;
    
    // Update selected button content
    const variantTitle = button.childNodes[0].textContent.trim();
    const pricesElement = button.querySelector('.variant-prices');
    
    if (variantTitle) {
      const titleElement = this.element.querySelector('.variant-title');
      if (titleElement) titleElement.textContent = variantTitle;
    }
    
    if (pricesElement) {
      const pricesContainer = this.element.querySelector('.variant-selected-prices');
      if (pricesContainer) pricesContainer.innerHTML = pricesElement.innerHTML;
    }

    // Update add to cart button text based on variant status
    const addToCartButton = document.querySelector('.shopify-product-form button');
    if (addToCartButton) {
      const isInStock = button.dataset.variantStatus === 'in-stock';
      setTimeout(() => {
        if(isInStock) {
          addToCartButton.textContent = window.themeVariables.strings.addToCartButton;
        } else {
          addToCartButton.textContent = window.themeVariables.strings.preOrderButton;
        }
        // Automatically trigger add to cart
        addToCartButton.click();
      }, 10);
    }
    
    // Update delivery estimate
    this.updateDeliveryEstimate();
    
    // Update state back to selected or closed
    this.updateState('selected');
    
    // Update form value if needed
    if (updateForm && this.formId) {
      const form = document.getElementById(this.formId);
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input && input.value !== variantId.toString()) {
          input.value = variantId;
          
          // Trigger change event to update product info
          const changeEvent = new CustomEvent('change');
          input.dispatchEvent(changeEvent);
          
          // Dispatch variant change event for the theme
          form.dispatchEvent(
            new CustomEvent("variant:change", {
              bubbles: true,
              detail: {
                variant: this.findVariantById(variantId)
              }
            })
          );
        }
      }
    }
  }
  
  updateDeliveryEstimate() {
    if (!this.deliveryEstimates || this.deliveryEstimates.length === 0) return;
    
    // Hide all delivery estimates
    this.deliveryEstimates.forEach(estimate => {
      estimate.style.display = 'none';
    });
    
    // If we have a selected variant, show its delivery estimate
    if (this.selectedVariantId) {
      const selectedEstimate = document.querySelector(`.delivery-estimate[data-var-id="${this.selectedVariantId}"]`);
      if (selectedEstimate) {
        selectedEstimate.style.display = 'block';
      }
    }
  }
  
  findVariantById(variantId) {
    return this.product.variants ? this.product.variants.find(variant => variant.id === variantId) : null;
  }
}

// Initialize all variant selector dropdowns on page load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-variant-selector]').forEach(selector => {
    new VariantSelectorDropdown(selector);
  });
}); 